import React from 'react'
import { InventoryTable, PanelTitle } from './InventoryShared';

function MasterSetupPage({ title, rows = [] }) {
    const columns = [
        { key: 'name', label: 'Name' },
        { key: 'type', label: 'Type' },
        { key: 'status', label: 'Status', badge: true },
    ];

    return (
        <section className='inventory-panel inventory-table-panel full'>
            <PanelTitle title={title} action='Add New' />
            <InventoryTable columns={columns} rows={rows} />
        </section>
    );
}

export default MasterSetupPage
